export default import.meta.ROLLDOWN_FILE_URL_LR7TQWb6vVWFYAGb7_hp7g